import React from "react";

/**
 * AIMA brand lockup.
 * variant: "horizontal" (header), "stacked" (footer), "mark" (square icon).
 */
const VARIANTS = {
    horizontal: {
        src: "/brand/logo_doar_scris.png",
        alt: "AIMA — AI Market Intelligence",
        defaultHeight: 34,
    },
    stacked: {
        src: "/brand/logo-1.webp",
        alt: "AIMA — AI Market Intelligence",
        defaultHeight: 88,
    },
    mark: {
        src: "/favicon.png",
        alt: "AIMA",
        defaultHeight: 48,
    },
};

export const AimaLogo = ({ variant = "horizontal", height, className = "" }) => {
    const cfg = VARIANTS[variant] || VARIANTS.horizontal;
    const h = height || cfg.defaultHeight;
    return (
        <img
            src={cfg.src}
            alt={cfg.alt}
            style={{ height: h, width: "auto" }}
            className={`block select-none ${className}`}
            draggable={false}
            data-testid={`aima-logo-${variant}`}
        />
    );
};

export default AimaLogo;
